{
  "2026": [
    {
      "entryType": "article",
      "citationKey": "de2026streamlined",
      "title": "A Streamlined Client-Server Architecture for Sustainable Sentiment Analysis System Using Textual Data",
      "authors": "De, Soumalya and Akhtar, Rahil and Umer, Saiyed and Rout, Ranjeet Kumar and Ali, GG Md Nawaz",
      "journal": "Computers, Materials & Continua",
      "volume": "88",
      "number": "1",
      "pages": "--",
      "year": "2026",
      "publisher": "Tech Science Press",
      "doi": "10.32604/cmc.2026.079340",
      "issn": "1546-2226",
      "url": "https://scholar.google.com/scholar?q=A+Streamlined+Client-Server+Architecture+for+Sustainable+Sentiment+Analysis+System+Using+Textual+Data",
      "urlSource": "http://www.techscience.com/cmc/v88n1/67314"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "shifa2026bridging",
      "title": "Bridging Lexical and Contextual Semantics for Adolescents' Health Sentiment Analysis: A Cross-Platform Study Using Large Language Models",
      "authors": "Shifa, Amima* and Ali, GG Md Nawaz and Henricks, Dylan",
      "booktitle": "2026 International Conference on Semantic Computing (ICSC)",
      "pages": "360--365",
      "year": "2026",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Bridging+Lexical+and+Contextual+Semantics+for+Adolescents%E2%80%99+Health+Sentiment+Analysis%3A+A+Cross-Platform+Study+Using+Large+Language+Models",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/11486568"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "poudel2026truth",
      "title": "Truth in the Age of AI: Fine-Tuning LLMs for Reliable Fake News Detection",
      "authors": "Poudel, Sajan and Sadat, Nazmus and Ali, GG Md Nawaz",
      "booktitle": "2026 International Conference on Semantic Computing (ICSC)",
      "pages": "354--359",
      "year": "2026",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Truth+in+the+Age+of+AI%3A+Fine-Tuning+LLMs+for+Reliable+Fake+News+Detection",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/11486523"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "fayyaz2026llms",
      "title": "LLMs in Fake News Detection: A Comparative Study of Zero-Shot and Fine-Tuned Open-Source Models",
      "authors": "Fayyaz, Imran* and Ali, GG Md Nawaz and Khairunnesa, Samantha S",
      "booktitle": "2026 International Conference on Semantic Computing (ICSC)",
      "pages": "238--245",
      "year": "2026",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=LLMs+in+Fake+News+Detection%3A+A+Comparative+Study+of+Zero-Shot+and+Fine-Tuned+Open-Source+Models",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/11486462"
    }
  ],
  "2025": [
    {
      "entryType": "article",
      "citationKey": "ghosh2025multimodal",
      "title": "A multimodal pain sentiment analysis system using ensembled deep learning approaches for IoT-enabled healthcare framework",
      "authors": "Ghosh, Anay and Umer, Saiyed and Dhara, Bibhas Chandra and Ali, GG Md Nawaz",
      "journal": "Sensors",
      "volume": "25",
      "number": "4",
      "pages": "1223",
      "year": "2025",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=A+multimodal+pain+sentiment+analysis+system+using+ensembled+deep+learning+approaches+for+IoT-enabled+healthcare+framework",
      "urlSource": "https://www.mdpi.com/1424-8220/25/4/1223"
    },
    {
      "entryType": "article",
      "citationKey": "mohammed2025gsaf",
      "title": "Gsaf: An ML-based sentiment analytics framework for understanding contemporary public sentiment and trends on key societal issues",
      "authors": "Mohammed, Abdul Moid Khan and Ali, GG Md Nawaz and Khairunnesa, Samantha S",
      "journal": "Information",
      "volume": "16",
      "number": "4",
      "pages": "271",
      "year": "2025",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Gsaf%3A+An+ML-based+sentiment+analytics+framework+for+understanding+contemporary+public+sentiment+and+trends+on+key+societal+issues",
      "urlSource": "https://www.mdpi.com/2078-2489/16/4/271"
    },
    {
      "entryType": "article",
      "citationKey": "sayed2025public",
      "title": "Public sentiment analysis of roadway work zones using social media data and machine learning models",
      "authors": "Sayed, Md Abu and Hossain, Md Amjad and Rahman, Md Mokhlesur and Ali, GG Md Nawaz and Islam, Mohammad Anwarul and Paul, Kamal Chandra and Qin, Xiao",
      "journal": "Data Science and Management",
      "year": "2025",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Public+sentiment+analysis+of+roadway+work+zones+using+social+media+data+and+machine+learning+models",
      "urlSource": "https://www.sciencedirect.com/science/article/pii/S2666764925000189"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "shifa2025leveraging",
      "title": "Leveraging Large Language Models for Automating Outpatients’ Message Classifications of Electronic Medical Records",
      "authors": "Shifa, Amima and Ali, GG Md Nawaz and Foulger, Roopa",
      "booktitle": "Healthcare",
      "volume": "13",
      "number": "23",
      "pages": "3052",
      "url": "https://www.mdpi.com/2227-9032/13/23/3052",
      "year": "2025",
      "organization": "MDPI",
      "urlSource": "https://www.mdpi.com/2227-9032/13/23/3052"
    },
    {
      "entryType": "article",
      "citationKey": "fayyaz2025advanced",
      "title": "Advanced Feature Engineering and Machine Learning Techniques for High Accurate Price Prediction of Heterogeneous Pre-Own Cars",
      "authors": "Fayyaz, Imran and Ali, GG Md Nawaz and Khairunnesa, Samantha S",
      "journal": "Vehicles",
      "volume": "7",
      "number": "3",
      "pages": "94",
      "year": "2025",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Advanced+Feature+Engineering+and+Machine+Learning+Techniques+for+High+Accurate+Price+Prediction+of+Heterogeneous+Pre-Own+Cars",
      "urlSource": "https://www.mdpi.com/2624-8921/7/3/94"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "mohammed2025understanding",
      "title": "Understanding Contemporary Public Sentiment and Trends on Key Societal",
      "authors": "Mohammed, Abdul Moid Khan and Ali, GG Md Nawaz",
      "booktitle": "Intelligent Computing: Proceedings of the 2025 Computing Conference, Volume 1",
      "volume": "1",
      "pages": "321",
      "year": "2025",
      "organization": "Springer Nature",
      "url": "https://scholar.google.com/scholar?q=Understanding+Contemporary+Public+Sentiment+and+Trends+on+Key+Societal",
      "urlSource": "https://link.springer.com/chapter/10.1007/978-3-031-92602-0_21"
    },
    {
      "entryType": "article",
      "citationKey": "baseer2025machine",
      "title": "Machine Learning-Based Compressive Strength Prediction in Pervious Concrete",
      "authors": "Baseer, Hamed Abdul and Ali, GG Md Nawaz",
      "journal": "CivilEng",
      "volume": "7",
      "number": "1",
      "pages": "3",
      "year": "2025",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Machine+Learning-Based+Compressive+Strength+Prediction+in+Pervious+Concrete",
      "urlSource": "https://www.mdpi.com/2673-4109/7/1/3"
    }
  ],
  "2024": [
    {
      "entryType": "article",
      "citationKey": "ali2024comprehensive",
      "title": "A comprehensive study and analysis of the third generation Partnership project’s 5G new radio for Vehicle-to-Everything Communication",
      "authors": "Ali, GG Md Nawaz and Sadat, Mohammad Nazmus and Miah, Md Suruz and Sharief, Sameer Ahmed and Wang, Yun",
      "journal": "Future Internet",
      "volume": "16",
      "number": "1",
      "pages": "21",
      "year": "2024",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=A+comprehensive+study+and+analysis+of+the+third+generation+Partnership+project%E2%80%99s+5G+new+radio+for+Vehicle-to-Everything+Communication",
      "urlSource": "https://www.mdpi.com/1999-5903/16/1/21"
    },
    {
      "entryType": "article",
      "citationKey": "wang20244",
      "title": "Computational Analysis of Wireless Modeling Sensor and",
      "authors": "Wang, Yun and Sadat, Mohammad Nazmus and Ali, GG Md Nawaz and Zhang, Yanping",
      "journal": "Computational Modeling and Simulation of Advanced Wireless Communication Systems",
      "pages": "89",
      "year": "2024",
      "publisher": "CRC Press",
      "url": "https://scholar.google.com/scholar?q=4+Computational+Analysis+of+Wireless+Modeling+Sensor+and",
      "urlSource": null
    },
    {
      "entryType": "incollection",
      "citationKey": "wang2024computational",
      "title": "Computational Modeling and Analysis of Wireless Sensor Networks",
      "authors": "Wang, Yun and Sadat, Mohammad Nazmus and Ali, GG Md Nawaz and Zhang, Yanping",
      "booktitle": "Computational Modeling and Simulation of Advanced Wireless Communication Systems",
      "pages": "89--111",
      "year": "2024",
      "publisher": "CRC Press",
      "url": "https://scholar.google.com/scholar?q=Computational+Modeling+and+Analysis+of+Wireless+Sensor+Networks",
      "urlSource": "https://pure.gonzaga.edu/p/en/research-outputs/ldabd7jkhpzg-1a17184e-0b71-4179-8881-7db9bfcdbb5c"
    }
  ],
  "2023": [
    {
      "entryType": "article",
      "citationKey": "rahman2023pandemic",
      "title": "Pandemic vulnerability index of US cities: A hybrid knowledge-based and data-driven approach",
      "authors": "Rahman, Md Shahinoor and Paul, Kamal Chandra and Rahman, Md Mokhlesur and Samuel, Jim and Thill, Jean-Claude and Hossain, Md Amjad and Ali, GG Md Nawaz",
      "journal": "Sustainable Cities and Society",
      "volume": "95",
      "pages": "104570",
      "year": "2023",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Pandemic+vulnerability+index+of+US+cities%3A+A+hybrid+knowledge-based+and+data-driven+approach",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2023comprehensive",
      "title": "A Comprehensive Study and Analysis of 3GPP’s 5G New Radio for V2X Communication",
      "authors": "Ali, GG Md Nawaz and Sadat, Mohammad Nazmus and Miah, Md Suruz and Sharief, Sameer Ahmed and Wang, Yun",
      "year": "2023",
      "publisher": "Preprints",
      "url": "https://scholar.google.com/scholar?q=A+Comprehensive+Study+and+Analysis+of+3GPP%E2%80%99s+5G+New+Radio+for+V2X+Communication",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2023performance",
      "title": "Performance analysis of 5G new radio V2X communication",
      "authors": "Ali, GG Md Nawaz and Sharief, Sameer Ahmed and Sadat, Mohammad Nazmus and Miah, Md Suruz",
      "booktitle": "2023 IEEE Wireless and Microwave Technology Conference (WAMICON)",
      "pages": "1--4",
      "year": "2023",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Performance+analysis+of+5G+new+radio+V2X+communication",
      "urlSource": "https://personalpages.bradley.edu/~smiah/Publications/OUT/b2hd-AlShSaMi2023-c1.html"
    }
  ],
  "2022": [
    {
      "entryType": "article",
      "citationKey": "jarrah2022time",
      "title": "The Time-Free Comparison Model for Fault Diagnosis in Wireless Ad Hoc Networks",
      "authors": "Jarrah, Hazim and Ali, GG Md Nawaz and Kumar, Arun and Chong, Peter HJ and Sarkar, Nurul I and Gutierrez, Jairo",
      "journal": "Mobile Networks and Applications",
      "volume": "27",
      "number": "2",
      "pages": "469--482",
      "year": "2022",
      "publisher": "Springer US New York",
      "url": "https://scholar.google.com/scholar?q=The+Time-Free+Comparison+Model+for+Fault+Diagnosis+in+Wireless+Ad+Hoc+Networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "chiputa2022enhancing",
      "title": "Enhancing handover for 5G mmWave mobile networks using jump Markov linear system and deep reinforcement learning",
      "authors": "Chiputa, Masoto and Zhang, Minglong and Ali, GG Md Nawaz and Chong, Peter Han Joo and Sabit, Hakilo and Kumar, Arun and Li, Hui",
      "journal": "Sensors",
      "volume": "22",
      "number": "3",
      "pages": "746",
      "year": "2022",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Enhancing+handover+for+5G+mmWave+mobile+networks+using+jump+Markov+linear+system+and+deep+reinforcement+learning",
      "urlSource": "https://www.mdpi.com/1424-8220/22/3/746"
    },
    {
      "entryType": "article",
      "citationKey": "hota2022performance",
      "title": "A performance analysis of VANETs propagation models and routing protocols",
      "authors": "Hota, Lopamudra and Nayak, Biraja Prasad and Kumar, Arun and Sahoo, Bibhudatta and Ali, GG Md Nawaz",
      "journal": "Sustainability",
      "volume": "14",
      "number": "3",
      "pages": "1379",
      "year": "2022",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=A+performance+analysis+of+VANETs+propagation+models+and+routing+protocols",
      "urlSource": "https://www.mdpi.com/2071-1050/14/3/1379"
    }
  ],
  "2021": [
    {
      "entryType": "article",
      "citationKey": "rahman2021machine",
      "title": "Machine learning on the COVID-19 pandemic, human mobility and air quality: A review",
      "authors": "Rahman, Md Mokhlesur and Paul, Kamal Chandra and Hossain, Md Amjad and Ali, GG Md Nawaz and Rahman, Md Shahinoor and Thill, Jean-Claude",
      "journal": "Ieee Access",
      "volume": "9",
      "pages": "72420--72450",
      "year": "2021",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Machine+learning+on+the+COVID-19+pandemic%2C+human+mobility+and+air+quality%3A+A+review",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "hota2021analysis",
      "title": "An analysis on contemporary MAC layer protocols in vehicular networks: State-of-the-art and future directions",
      "authors": "Hota, Lopamudra and Nayak, Biraja Prasad and Kumar, Arun and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "journal": "Future Internet",
      "volume": "13",
      "number": "11",
      "pages": "287",
      "year": "2021",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=An+analysis+on+contemporary+MAC+layer+protocols+in+vehicular+networks%3A+State-of-the-art+and+future+directions",
      "urlSource": "https://www.mdpi.com/1999-5903/13/11/287"
    },
    {
      "entryType": "article",
      "citationKey": "yang2021social",
      "title": "Social Video Advertisement Replacement and its Evaluation in Convolutional Neural Networks",
      "authors": "Yang, Cheng and Yu, Xiang and Kumar, Arun and Ali, GG Md Nawaz and Chong, Peter Han Joo and Lam, Patrick",
      "journal": "ELCVIA Electronic Letters on Computer Vision and Image Analysis",
      "volume": "20",
      "number": "1",
      "pages": "117--136",
      "year": "2021",
      "url": "https://scholar.google.com/scholar?q=Social+Video+Advertisement+Replacement+and+its+Evaluation+in+Convolutional+Neural+Networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2021public",
      "title": "Public perceptions of COVID-19 vaccines: Policy implications from US spatiotemporal sentiment analytics",
      "authors": "Ali, GG Md Nawaz and Rahman, Md Mokhlesur and Hossain, Md Amjad and Rahman, Md Shahinoor and Paul, Kamal Chandra and Thill, Jean-Claude and Samuel, Jim",
      "booktitle": "Healthcare",
      "volume": "9",
      "number": "9",
      "pages": "1110",
      "year": "2021",
      "organization": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Public+perceptions+of+COVID-19+vaccines%3A+Policy+implications+from+US+spatiotemporal+sentiment+analytics",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "zheng2021deep",
      "title": "Deep learning algorithm for picture frame detection on social media videos",
      "authors": "Zheng, Fucheng and Yang, Cheng and Chong, Peter Han Joo and Wang, George and Ali, GG Md Nawaz and Lam, Patrick",
      "booktitle": "2021 IEEE International Conference on Internet of Things and Intelligence Systems (IoTaIS)",
      "pages": "149--155",
      "year": "2021",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Deep+learning+algorithm+for+picture+frame+detection+on+social+media+videos",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "rahman2021socioeconomic",
      "title": "Socioeconomic factors analysis for COVID-19 US reopening sentiment with Twitter and census data",
      "authors": "Rahman, Md Mokhlesur and Ali, GG Md Nawaz and Li, Xue Jun and Samuel, Jim and Paul, Kamal Chandra and Chong, Peter HJ and Yakubov, Michael",
      "journal": "Heliyon",
      "volume": "7",
      "number": "2",
      "year": "2021",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Socioeconomic+factors+analysis+for+COVID-19+US+reopening+sentiment+with+Twitter+and+census+data",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "chiputa2021enhancing",
      "title": "Enhancing Handover for 5G Mobile Networks using Jump Markov Linear System and Deep Reinforcement Learning",
      "authors": "Chiputa, Masoto and Zhang, Minglong and Ali, GG Md Nawaz and Chong, Peter Han Joo and Sabit, Hakilo and Kumar, Arun and Li, Hui",
      "year": "2021",
      "publisher": "Preprints",
      "url": "https://scholar.google.com/scholar?q=Enhancing+Handover+for+5G+Mobile+Networks+using+Jump+Markov+Linear+System+and+Deep+Reinforcement+Learning",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "yoon2021performance",
      "title": "Performance of decentralized cooperative perception in V2V connected traffic",
      "authors": "Yoon, DoHyun Daniel and Ayalew, Beshah and Ali, GG Md Nawaz",
      "journal": "IEEE Transactions on Intelligent Transportation Systems",
      "volume": "23",
      "number": "7",
      "pages": "6850--6863",
      "year": "2021",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Performance+of+decentralized+cooperative+perception+in+V2V+connected+traffic",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/9387631"
    }
  ],
  "2020": [
    {
      "entryType": "article",
      "citationKey": "rahman2020twitter",
      "title": "Twitter and census data analytics to explore socioeconomic factors for post-covid-19 reopening sentiment",
      "authors": "Rahman, Md Mokhlesur and Ali, GG Md Nawaz and Li, Xue Jun and Paul, Kamal Chandra and Chong, Peter HJ",
      "journal": "arXiv preprint arXiv:2007.00054",
      "year": "2020",
      "url": "https://scholar.google.com/scholar?q=Twitter+and+census+data+analytics+to+explore+socioeconomic+factors+for+post-covid-19+reopening+sentiment",
      "urlSource": "https://arxiv.org/abs/2007.00054"
    },
    {
      "entryType": "article",
      "citationKey": "ali2020feedbackless",
      "title": "Feedbackless relaying for enhancing reliability of connected vehicles",
      "authors": "Ali, GG Md Nawaz and Ayalew, Beshah and Vahidi, Ardalan and Noor-A-Rahim, Md",
      "journal": "IEEE Transactions on Vehicular Technology",
      "volume": "69",
      "number": "5",
      "pages": "4621--4634",
      "year": "2020",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Feedbackless+relaying+for+enhancing+reliability+of+connected+vehicles",
      "urlSource": "https://doi.org/10.1109/TVT.2020.2980848"
    },
    {
      "entryType": "techreport",
      "citationKey": "vahidi2020boosting",
      "title": "Boosting Energy Efficiency of Heterogeneous Connected Automated Vehicle (CAV) Fleets via Anticipative and Cooperative Vehicle Guidance",
      "authors": "Vahidi, Ardalan and Jia, Yunyi and Ayalew, Beshah and Karbowski, Dominik and Taiber, Joachim G and Fayazi, Ali Reza and Ali, G and Dollar, Robert Austin and Ard, Tyler and Guo, Longxiang and others",
      "year": "2020",
      "institution": "Clemson Univ., SC (United States)",
      "url": "https://scholar.google.com/scholar?q=Boosting+Energy+Efficiency+of+Heterogeneous+Connected+Automated+Vehicle+%28CAV%29+Fleets+via+Anticipative+and+Cooperative+Vehicle+Guidance",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "samuel2020feeling",
      "title": "Feeling positive about reopening? New normal scenarios from COVID-19 US reopen sentiment analytics",
      "authors": "Samuel, Jim and Rahman, Md Mokhlesur and Ali, GG Md Nawaz and Samuel, Yana and Pelaez, Alexander and Chong, Peter Han Joo and Yakubov, Michael",
      "journal": "Ieee Access",
      "volume": "8",
      "pages": "142173--142190",
      "year": "2020",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Feeling+positive+about+reopening%3F+New+normal+scenarios+from+COVID-19+US+reopen+sentiment+analytics",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2020survey",
      "title": "A survey on resource allocation in vehicular networks",
      "authors": "Noor-A-Rahim, Md and Liu, Zilong and Lee, Haeyoung and Ali, GG Md Nawaz and Pesch, Dirk and Xiao, Pei",
      "journal": "IEEE transactions on intelligent transportation systems",
      "volume": "23",
      "number": "2",
      "pages": "701--721",
      "year": "2020",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=A+survey+on+resource+allocation+in+vehicular+networks",
      "urlSource": "https://doi.org/10.1109/TITS.2020.3019322"
    },
    {
      "entryType": "article",
      "citationKey": "samuel2020covid",
      "title": "Covid-19 public sentiment insights and machine learning for tweets classification",
      "authors": "Samuel, Jim and Ali, GG Md Nawaz and Rahman, Md Mokhlesur and Esawi, Ek and Samuel, Yana",
      "journal": "Information",
      "volume": "11",
      "number": "6",
      "pages": "314",
      "year": "2020",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Covid-19+public+sentiment+insights+and+machine+learning+for+tweets+classification",
      "urlSource": "https://www.mdpi.com/2078-2489/11/6/314"
    },
    {
      "entryType": "article",
      "citationKey": "mohan2020machine",
      "title": "Machine Learning Algorithm for NLOS Millimeter Wave in 5G V2X Communication",
      "authors": "Mohan, Deepika and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "journal": "arXiv preprint arXiv:2012.12123",
      "year": "2020",
      "url": "https://scholar.google.com/scholar?q=Machine+Learning+Algorithm+for+NLOS+Millimeter+Wave+in+5G+V2X+Communication",
      "urlSource": "https://arxiv.org/abs/2012.12123"
    },
    {
      "entryType": "article",
      "citationKey": "samuel2020feeling",
      "title": "Feeling like it is time to reopen now? covid-19 new normal scenarios based on reopening sentiment analytics",
      "authors": "Samuel, Jim and Rahman, Md Mokhlesur and Ali, GG Md Nawaz and Samuel, Yana and Pelaez, Alexander",
      "journal": "arXiv preprint arXiv:2005.10961",
      "year": "2020",
      "url": "https://scholar.google.com/scholar?q=Feeling+like+it+is+time+to+reopen+now%3F+covid-19+new+normal+scenarios+based+on+reopening+sentiment+analytics",
      "urlSource": "https://arxiv.org/abs/2005.10961"
    }
  ],
  "2019": [
    {
      "entryType": "article",
      "citationKey": "ali2019towards",
      "title": "Towards efficient and scalable implementation for coding-based on-demand data broadcast",
      "authors": "Ali, GG Md Nawaz and Liu, Kai and Lee, Victor CS and Chong, Peter HJ and Guan, Yong Liang and Chen, Jun",
      "journal": "Computer Networks",
      "volume": "154",
      "pages": "88--104",
      "year": "2019",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Towards+efficient+and+scalable+implementation+for+coding-based+on-demand+data+broadcast",
      "urlSource": "https://www.sciencedirect.com/science/article/pii/S138912861930221X"
    },
    {
      "entryType": "article",
      "citationKey": "mondal2019multi",
      "title": "A Multi-Stage Encryption Technique to Enhance the Secrecy of Image.",
      "authors": "Mondal, Arindom and Alam, Kazi Md Rokibul and Ali, GG Md Nawaz and Chong, Peter Han Joo and others",
      "journal": "KSII Transactions on Internet & Information Systems",
      "volume": "13",
      "number": "5",
      "year": "2019",
      "url": "https://scholar.google.com/scholar?q=A+Multi-Stage+Encryption+Technique+to+Enhance+the+Secrecy+of+Image.",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "kaur2019network",
      "title": "Network driven performance analysis in connected vehicular networks",
      "authors": "Kaur, Manveen and Ali, GG Md Nawaz and Rayamajhi, Anjan and Ayalew, Beshah and Martin, Jim",
      "booktitle": "2019 IEEE 90th Vehicular Technology Conference (VTC2019-Fall)",
      "pages": "1--6",
      "year": "2019",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Network+driven+performance+analysis+in+connected+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2019reliable",
      "title": "Reliable state estimation of an unmanned aerial vehicle over a distributed wireless IoT network",
      "authors": "Noor-A-Rahim, MD and Khyam, Mohammad Omar and Ali, GG Md Nawaz and Liu, Zilong and Pesch, Dirk and Chong, Peter HJ",
      "journal": "IEEE Transactions on Reliability",
      "volume": "68",
      "number": "3",
      "pages": "1061--1069",
      "year": "2019",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Reliable+state+estimation+of+an+unmanned+aerial+vehicle+over+a+distributed+wireless+IoT+network",
      "urlSource": "https://doi.org/10.1109/TR.2019.2891994"
    },
    {
      "entryType": "article",
      "citationKey": "zhang2019novel",
      "title": "A novel hybrid mac protocol for basic safety message broadcasting in vehicular networks",
      "authors": "Zhang, Minglong and Ali, GG Md Nawaz and Chong, Peter Han Joo and Seet, Boon-Chong and Kumar, Arun",
      "journal": "IEEE Transactions on Intelligent Transportation Systems",
      "volume": "21",
      "number": "10",
      "pages": "4269--4282",
      "year": "2019",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=A+novel+hybrid+mac+protocol+for+basic+safety+message+broadcasting+in+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "yoon2019cooperative",
      "title": "Cooperative perception in connected vehicle traffic under field-of-view and participation variations",
      "authors": "Yoon, DoHyun Daniel and Ali, GG Md Nawaz and Ayalew, Beshah",
      "booktitle": "2019 IEEE 2nd Connected and Automated Vehicles Symposium (CAVS)",
      "pages": "1--6",
      "year": "2019",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Cooperative+perception+in+connected+vehicle+traffic+under+field-of-view+and+participation+variations",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2019analysis",
      "title": "Analysis of reliabilities under different path loss models in urban/sub-urban vehicular networks",
      "authors": "Ali, GG Md Nawaz and Ayalew, Beshah and Vahidi, Ardalan and Noor-A-Rahim, Md",
      "booktitle": "2019 IEEE 90th Vehicular Technology Conference (VTC2019-Fall)",
      "pages": "1--6",
      "year": "2019",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Analysis+of+reliabilities+under+different+path+loss+models+in+urban%2Fsub-urban+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2019cooperative",
      "title": "Cooperative cache transfer-based on-demand network coded broadcast in vehicular networks",
      "authors": "Ali, GG Md Nawaz and Noor-A-Rahim, MD and Rahman, Md Ashiqur and Ayalew, Beshah and Chong, Peter HJ and Guan, Yong Liang",
      "journal": "ACM Transactions on Embedded Computing Systems (TECS)",
      "volume": "18",
      "number": "4",
      "pages": "1--20",
      "year": "2019",
      "publisher": "ACM New York, NY, USA",
      "url": "https://scholar.google.com/scholar?q=Cooperative+cache+transfer-based+on-demand+network+coded+broadcast+in+vehicular+networks",
      "urlSource": "https://dl.acm.org/doi/abs/10.1145/3329865"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "yoon2019data",
      "title": "Data association and fusion framework for decentralized multi-vehicle cooperative perception",
      "authors": "Yoon, DoHyun Daniel and Ali, GG Md Nawaz and Ayalew, Beshah",
      "booktitle": "International Design Engineering Technical Conferences and Computers and Information in Engineering Conference",
      "volume": "59216",
      "pages": "V003T01A019",
      "year": "2019",
      "organization": "American Society of Mechanical Engineers",
      "url": "https://scholar.google.com/scholar?q=Data+association+and+fusion+framework+for+decentralized+multi-vehicle+cooperative+perception",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2019performance",
      "title": "Performance Analysis of On-Demand Scheduling with and without Network Coding in Wireless Broadcast",
      "authors": "Ali, GG Md Nawaz and Lee, Victor CS and Meng, Yuxuan and Chong, Peter HJ and Chen, Jun",
      "journal": "Future internet",
      "volume": "11",
      "number": "12",
      "pages": "248",
      "year": "2019",
      "publisher": "MDPI",
      "url": "https://scholar.google.com/scholar?q=Performance+Analysis+of+On-Demand+Scheduling+with+and+without+Network+Coding+in+Wireless+Broadcast",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2019broadcast",
      "title": "Broadcast performance analysis and improvements of the LTE-V2V autonomous mode at road intersection",
      "authors": "Noor-A-Rahim, Md and Ali, GG Md Nawaz and Guan, Yong Liang and Ayalew, Beshah and Chong, Peter Han Joo and Pesch, Dirk",
      "journal": "IEEE Transactions on Vehicular Technology",
      "volume": "68",
      "number": "10",
      "pages": "9359--9369",
      "year": "2019",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Broadcast+performance+analysis+and+improvements+of+the+LTE-V2V+autonomous+mode+at+road+intersection",
      "urlSource": "https://doi.org/10.1109/TVT.2019.2936799"
    },
    {
      "entryType": "article",
      "citationKey": "ali2019broadcast",
      "title": "Broadcast performance analysis and improvements of the LTE-V2V autonomous mode at road intersection",
      "authors": "Ali, GG Md Nawaz and Guan, Yong Liang and Ayalew, Beshah and Chong, Peter Han Joo and Pesch, Dirk and others",
      "year": "2019",
      "publisher": "Institute of Electrical and Electronics Engineers (IEEE)",
      "url": "https://scholar.google.com/scholar?q=Broadcast+performance+analysis+and+improvements+of+the+LTE-V2V+autonomous+mode+at+road+intersection",
      "urlSource": "https://doi.org/10.1109/TVT.2019.2936799"
    }
  ],
  "2018": [
    {
      "entryType": "article",
      "citationKey": "ali2018efficient",
      "title": "Efficient real-time coding-assisted heterogeneous data access in vehicular networks",
      "authors": "Ali, GG Md Nawaz and Noor-A-Rahim, Md and Rahman, Md Ashiqur and Samantha, Syeda Khairunnesa and Chong, Peter Han Joo and Guan, Yong Liang",
      "journal": "IEEE Internet of Things Journal",
      "volume": "5",
      "number": "5",
      "pages": "3499--3512",
      "year": "2018",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Efficient+real-time+coding-assisted+heterogeneous+data+access+in+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "alam2018untraceable",
      "title": "An Untraceable Voting Scheme Based on Pairs of Signatures.",
      "authors": "Alam, Kazi Md Rokibul and Maruf, Adnan and Rakib, Md Rezaur Rahman and Ali, GG Md Nawaz and Chong, Peter Han Joo and Morimoto, Yasuhiko",
      "journal": "Int. J. Netw. Secur.",
      "volume": "20",
      "number": "4",
      "pages": "774--787",
      "year": "2018",
      "url": "https://scholar.google.com/scholar?q=An+Untraceable+Voting+Scheme+Based+on+Pairs+of+Signatures.",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2018practical",
      "title": "Practical relay code design based on protograph codes",
      "authors": "Noor-A-Rahim, Md and Ali, GG Md Nawaz and Guan, Yong Liang",
      "journal": "IET Communications",
      "volume": "12",
      "number": "3",
      "pages": "334--339",
      "year": "2018",
      "publisher": "Wiley Online Library",
      "url": "https://scholar.google.com/scholar?q=Practical+relay+code+design+based+on+protograph+codes",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2018analysis",
      "title": "Analysis and improvement of reliability through coding for safety message broadcasting in urban vehicular networks",
      "authors": "Ali, GG Md Nawaz and Noor-A-Rahim, Md and Chong, Peter Han Joo and Guan, Yong Liang",
      "journal": "IEEE Transactions on Vehicular Technology",
      "volume": "67",
      "number": "8",
      "pages": "6774--6787",
      "year": "2018",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Analysis+and+improvement+of+reliability+through+coding+for+safety+message+broadcasting+in+urban+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2018performance",
      "title": "Performance analysis of IEEE 802.11 p safety message broadcast with and without relaying at road intersection",
      "authors": "Noor-A-Rahim, Md and Ali, GG Md Nawaz and Nguyen, Hieu and Guan, Yong Liang",
      "journal": "IEEE Access",
      "volume": "6",
      "pages": "23786--23799",
      "year": "2018",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Performance+analysis+of+IEEE+802.11+p+safety+message+broadcast+with+and+without+relaying+at+road+intersection",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "noor2018delay",
      "title": "Delay-universal channel coding with feedback",
      "authors": "Noor-A-Rahim, Md and Khyam, Mohammad Omar and Guan, Yong Liang and Ali, GG Md Nawaz and Nguyen, Khoa D and Lechner, Gottfried",
      "journal": "IEEE Access",
      "volume": "6",
      "pages": "37918--37931",
      "year": "2018",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Delay-universal+channel+coding+with+feedback",
      "urlSource": null
    }
  ],
  "2017": [
    {
      "entryType": "article",
      "citationKey": "morimoto2017offline",
      "title": "An offline electronic payment system based on an untraceable blind signature scheme",
      "authors": "Morimoto, Yasuhiko and Ali, GG Md Nawaz and Kutubi, Md Abdullah Al Rahat and Alam, Kazi Md Rokibul and Tahsin, Rafaf and Chong, Peter Han Joo",
      "year": "2017",
      "url": "https://scholar.google.com/scholar?q=An+offline+electronic+payment+system+based+on+an+untraceable+blind+signature+scheme",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "kutubi2017offline",
      "title": "An offline electronic payment system based on an untraceable blind signature scheme",
      "authors": "Kutubi, Md Abdullah Al Rahat and Alam, Kazi Md Rokibul and Tahsin, Rafaf and Ali, GG Md Nawaz and Chong, Peter Han Joo and Morimoto, Yasuhiko",
      "journal": "KSII Transactions on Internet and Information Systems (TIIS)",
      "volume": "11",
      "number": "5",
      "pages": "2628--2645",
      "year": "2017",
      "publisher": "Korean Society for Internet Information",
      "url": "https://scholar.google.com/scholar?q=An+offline+electronic+payment+system+based+on+an+untraceable+blind+signature+scheme",
      "urlSource": null
    }
  ],
  "2016": [
    {
      "entryType": "inproceedings",
      "citationKey": "zhao2016energy",
      "title": "An energy-efficient and self-regioning based RPL for low-power and lossy networks",
      "authors": "Zhao, Ming and Ali, GG Md Nawaz and Lu, Rongxing and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE 84th Vehicular Technology Conference (VTC-Fall)",
      "pages": "1--6",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=An+energy-efficient+and+self-regioning+based+RPL+for+low-power+and+lossy+networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "moyeen2016automatic",
      "title": "An automatic layout faults detection technique in responsive web pages considering JavaScript defined dynamic layouts",
      "authors": "Moyeen, MA and Ali, GG Md Nawaz and Chong, Peter Han Joo and Islam, Nazmul",
      "booktitle": "2016 3rd International Conference on Electrical Engineering and Information Communication Technology (ICEEICT)",
      "pages": "1--5",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=An+automatic+layout+faults+detection+technique+in+responsive+web+pages+considering+JavaScript+defined+dynamic+layouts",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "shaikh2016parallel",
      "title": "Parallel matricization for nD array operations",
      "authors": "Shaikh, Md Abu Hanif and Ali, GG Md Nawaz and Chong, Peter Han Joo and Guan, Yong Liang",
      "booktitle": "2016 IEEE Region 10 Conference (TENCON)",
      "pages": "2432--2435",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Parallel+matricization+for+nD+array+operations",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "sudheera2016delay",
      "title": "Delay efficient software defined networking based architecture for vehicular networks",
      "authors": "Sudheera, KL Kushan and Ma, Maode and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE International Conference on Communication Systems (ICCS)",
      "pages": "1--6",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Delay+efficient+software+defined+networking+based+architecture+for+vehicular+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2016striking",
      "title": "On striking the balance between the fairness of service and throughput in roadside units based vehicular ad hoc networks",
      "authors": "Ali, GG Md Nawaz and Mollah, Md Abdus Salim and Samantha, Syeda Khairunnesa and Chong, Peter Han Joo and Guan, Yong Liang",
      "journal": "International Journal of Vehicle Autonomous Systems",
      "volume": "13",
      "number": "2",
      "pages": "168--187",
      "year": "2016",
      "publisher": "Inderscience Publishers (IEL)",
      "url": "https://scholar.google.com/scholar?q=On+striking+the+balance+between+the+fairness+of+service+and+throughput+in+roadside+units+based+vehicular+ad+hoc+networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "zhao2016cloud",
      "title": "A cloud-based network architecture for big data services",
      "authors": "Zhao, Ming and Kumar, Arun and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE 14th Intl Conf on Dependable, Autonomic and Secure Computing, 14th Intl Conf on Pervasive Intelligence and Computing, 2nd Intl Conf on Big Data Intelligence and Computing and Cyber Science and Technology Congress (DASC/PiCom/DataCom/CyberSciTech)",
      "pages": "654--659",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=A+cloud-based+network+architecture+for+big+data+services",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "shaikh2016efficient",
      "title": "Efficient matricization of nD array with CUDA and its evaluation",
      "authors": "Shaikh, Md Abu Hanif and Hasan, KM Azharul and Ali, GG Md Nawaz and Chafii, Marwa and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE Intl Conference on Computational Science and Engineering (CSE) and IEEE Intl Conference on Embedded and Ubiquitous Computing (EUC) and 15th Intl Symposium on Distributed Computing and Applications for Business Engineering (DCABES)",
      "pages": "246--252",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Efficient+matricization+of+nD+array+with+CUDA+and+its+evaluation",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "aung2016information",
      "title": "Information epidemics control for data delivery in opportunistic networks",
      "authors": "Aung, Cherry Ye and Ali, GG Md Nawaz and Zhao, Ming and Cai, Ruojun and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE International Conference on Communications (ICC)",
      "pages": "1--6",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Information+epidemics+control+for+data+delivery+in+opportunistic+networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2016efficient",
      "title": "On efficient data dissemination using network coding in multi-rsu vehicular ad hoc networks",
      "authors": "Ali, GG Md Nawaz and Rahman, Md Ashiqur and Chong, Peter Han Joo and Samantha, Syeda Khairunnesa",
      "booktitle": "2016 IEEE 83rd Vehicular Technology Conference (VTC Spring)",
      "pages": "1--5",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=On+efficient+data+dissemination+using+network+coding+in+multi-rsu+vehicular+ad+hoc+networks",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "rahman2016accessing",
      "title": "On Accessing Heterogeneous Data Items using Network Coding in Wireless Broadcast",
      "authors": "Rahman, Md Ashiqur and Ali, GG Md Nawaz and Gao, Yumeng and Samantha, Syeda K and Chong, Peter HJ",
      "booktitle": "2016 IEEE 84th Vehicular Technology Conference (VTC-Fall)",
      "pages": "1--5",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=On+Accessing+Heterogeneous+Data+Items+using+Network+Coding+in+Wireless+Broadcast",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "islam2016expedite",
      "title": "An expedite group key establishment protocol for Flying Ad-Hoc Network (FANET)",
      "authors": "Islam, Nazmul and Hossain, Md Kowsar and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "booktitle": "2016 5th International Conference on Informatics, Electronics and Vision (ICIEV)",
      "pages": "312--315",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=An+expedite+group+key+establishment+protocol+for+Flying+Ad-Hoc+Network+%28FANET%29",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "moyeen2016wireless",
      "title": "A wireless vehicular traffic service management scheme",
      "authors": "Moyeen, MA and Ali, GG Md Nawaz and Chong, Peter Han Joo and Islam, Nazmul",
      "booktitle": "2016 3rd International Conference on Electrical Engineering and Information Communication Technology (ICEEICT)",
      "pages": "1--5",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=A+wireless+vehicular+traffic+service+management+scheme",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "gao2016network",
      "title": "Network coding based BSM broadcasting at road intersection in V2V communication",
      "authors": "Gao, Yumeng and Ali, GG Md Nawaz and Chong, Peter Han Joo and Guan, Yong Liang",
      "booktitle": "2016 IEEE 84th Vehicular Technology Conference (VTC-Fall)",
      "pages": "1--5",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Network+coding+based+BSM+broadcasting+at+road+intersection+in+V2V+communication",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "aung2016cluster",
      "title": "Cluster-based cooperative data forwarding with multi-radio multi-channel for multi-flow wireless networks",
      "authors": "Aung, Cherry Ye and Ali, GG Md Nawaz and Chong, Peter Han Joo",
      "year": "2016",
      "url": "https://scholar.google.com/scholar?q=Cluster-based+cooperative+data+forwarding+with+multi-radio+multi-channel+for+multi-flow+wireless+networks",
      "urlSource": null
    },
    {
      "entryType": "article",
      "citationKey": "ali2016efficient",
      "title": "Efficient data dissemination in cooperative multi-RSU vehicular ad hoc networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chong, Peter Han Joo and Samantha, Syeda Khairunnesa and Chan, Edward",
      "journal": "Journal of Systems and Software",
      "volume": "117",
      "pages": "508--527",
      "year": "2016",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Efficient+data+dissemination+in+cooperative+multi-RSU+vehicular+ad+hoc+networks+%28VANETs%29",
      "urlSource": "https://www.sciencedirect.com/science/article/abs/pii/S0164121216300218"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "cai2016simulation",
      "title": "Simulation study of routing attacks under network coding environment",
      "authors": "Cai, Ruo Jun and Ali, GG Md Nawaz and Aung, Cherry Ye and Zhao, Ming and Chong, Peter Han Joo",
      "booktitle": "2016 IEEE International Conference on Communications (ICC)",
      "pages": "1--6",
      "year": "2016",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Simulation+study+of+routing+attacks+under+network+coding+environment",
      "urlSource": null
    }
  ],
  "2014": [
    {
      "entryType": "article",
      "citationKey": "ali2014scheduling",
      "title": "On scheduling data access with cooperative load balancing in vehicular ad hoc networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward and Li, Wenzhong",
      "journal": "The Journal of Supercomputing",
      "volume": "67",
      "number": "2",
      "pages": "438--468",
      "year": "2014",
      "publisher": "Springer US Boston",
      "url": "https://scholar.google.com/scholar?q=On+scheduling+data+access+with+cooperative+load+balancing+in+vehicular+ad+hoc+networks+%28VANETs%29",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2014efficient",
      "title": "An efficient cooperative load balancing approach in rsu-based vehicular ad hoc networks (vanets)",
      "authors": "Ali, GG Md Nawaz and Mollah, Md Abdus Salim and Samantha, Syeda Khairunnesa and Mahmud, Saifuddin",
      "booktitle": "2014 IEEE International Conference on Control System, Computing and Engineering (ICCSCE 2014)",
      "pages": "52--57",
      "year": "2014",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=An+efficient+cooperative+load+balancing+approach+in+rsu-based+vehicular+ad+hoc+networks+%28vanets%29",
      "urlSource": null
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2014performance",
      "title": "Performance improvement in applying network coding to on-demand scheduling algorithms for broadcasts in wireless networks",
      "authors": "Ali, GG Md Nawaz and Meng, Yuxuan and Lee, V and Liu, Kai and Chan, Edward",
      "booktitle": "International Multi-Conference on Computing in the Global Information Technology (ICCGI)",
      "year": "2014",
      "url": "https://scholar.google.com/scholar?q=Performance+improvement+in+applying+network+coding+to+on-demand+scheduling+algorithms+for+broadcasts+in+wireless+networks",
      "urlSource": "https://d1wqtxts1xzle7.cloudfront.net/84435802/download_full-libre.pdf?1650337841=&response-content-disposition=inline%3B+filename%3DICCGI_2014_The_Ninth_International_Multi.pdf&Expires=1777837271&Signature=cHqFNFwWVFurH6DrLSBDidujB3VX8Xm6Ka37s8ZmiR-FYkotCdZuJA6FIJ1xsEQJbKO8vh5WnFjZqbk~K~g8aKil3wJiatUF0281bsn262Kgv6rYE0F2Q0ewmXTRuMb-1cjmJu7hd~Xduckh3J8RpVlZ9rLHf2lSyXhYs~bf7nQEjt1YzkwM3riTX4fMF~zNabIealStvVGrcflnjBSu~VkfoXRMZfuPiAIFzieabRzYPRu-jTP7nh-jcwADsQuox1INzo6Pl7bx~WpTixAyEy3oONC5sWFK-3hucID6OPGJWZHPqnv01jSOY62S3QTPM1b1dPC828-7B3tNPsAiww__&Key-Pair-Id=APKAJLOHF5GGSLRBV4ZA#page=148"
    },
    {
      "entryType": "article",
      "citationKey": "ali2014admission",
      "title": "Admission control-based multichannel data broadcasting for real-time multi-item queries",
      "authors": "Ali, GG Md Nawaz and Lee, Victor CS and Chan, Edward and Li, Minming and Liu, Kai and Lv, Jingsong and Chen, Jun",
      "journal": "IEEE Transactions on Broadcasting",
      "volume": "60",
      "number": "4",
      "pages": "589--605",
      "year": "2014",
      "publisher": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Admission+control-based+multichannel+data+broadcasting+for+real-time+multi-item+queries",
      "urlSource": "https://doi.org/10.1109/TBC.2014.2364533"
    }
  ],
  "2013": [
    {
      "entryType": "inproceedings",
      "citationKey": "ali2013scheduling",
      "title": "On Scheduling Real-Time Multi-item Queries in Multi-RSU Vehicular Ad Hoc Networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward and Li, Wenzhong",
      "booktitle": "2013 27th International Conference on Advanced Information Networking and Applications Workshops",
      "pages": "7--12",
      "year": "2013",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=On+Scheduling+Real-Time+Multi-item+Queries+in+Multi-RSU+Vehicular+Ad+Hoc+Networks+%28VANETs%29",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/6550365"
    },
    {
      "entryType": "article",
      "citationKey": "ali2013supporting",
      "title": "Supporting real-time multiple data items query in multi-RSU vehicular ad hoc networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward and Li, Wenzhong",
      "journal": "Journal of Systems and Software",
      "volume": "86",
      "number": "8",
      "pages": "2127--2142",
      "year": "2013",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Supporting+real-time+multiple+data+items+query+in+multi-RSU+vehicular+ad+hoc+networks+%28VANETs%29",
      "urlSource": "https://www.sciencedirect.com/science/article/pii/S0164121213000769"
    },
    {
      "entryType": "article",
      "citationKey": "chen2013efficient",
      "title": "Efficient processing of requests with network coding in on-demand data broadcast environments",
      "authors": "Chen, Jun and Lee, Victor CS and Liu, Kai and Ali, GG Md Nawaz and Chan, Edward",
      "journal": "Information Sciences",
      "volume": "232",
      "pages": "27--43",
      "year": "2013",
      "publisher": "Elsevier",
      "url": "https://scholar.google.com/scholar?q=Efficient+processing+of+requests+with+network+coding+in+on-demand+data+broadcast+environments",
      "urlSource": "https://dl.acm.org/doi/10.1016/j.ins.2012.12.044"
    }
  ],
  "2011": [
    {
      "entryType": "inproceedings",
      "citationKey": "ali2011co",
      "title": "Co-operative data access in multiple road side units (rsus)-based vehicular ad hoc networks (vanets)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward",
      "booktitle": "2011 Australasian Telecommunication Networks and Applications Conference (ATNAC)",
      "pages": "1--6",
      "year": "2011",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Co-operative+data+access+in+multiple+road+side+units+%28rsus%29-based+vehicular+ad+hoc+networks+%28vanets%29",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/6096651"
    },
    {
      "entryType": "article",
      "citationKey": "ali2011co",
      "title": "Co-operative load balancing in vehicular ad hoc networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward",
      "journal": "International Journal of Wireless Networks and Broadband Technologies (IJWNBT)",
      "volume": "1",
      "number": "4",
      "pages": "1--21",
      "year": "2011",
      "publisher": "IGI Global Scientific Publishing",
      "url": "https://scholar.google.com/scholar?q=Co-operative+load+balancing+in+vehicular+ad+hoc+networks+%28VANETs%29",
      "urlSource": "https://www.igi-global.com/article/content/64624"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2011two",
      "title": "Two-step joint scheduling scheme for road side units (RSUs)-based vehicular ad hoc networks (VANETs)",
      "authors": "Ali, GG Md Nawaz and Chan, Edward and Li, Wenzhong",
      "booktitle": "International Conference on Database Systems for Advanced Applications",
      "pages": "453--464",
      "year": "2011",
      "organization": "Springer Berlin Heidelberg Berlin, Heidelberg",
      "url": "https://scholar.google.com/scholar?q=Two-step+joint+scheduling+scheme+for+road+side+units+%28RSUs%29-based+vehicular+ad+hoc+networks+%28VANETs%29",
      "urlSource": "https://link.springer.com/chapter/10.1007/978-3-642-20244-5_43"
    }
  ],
  "2010": [
    {
      "entryType": "article",
      "citationKey": "ali2010efficient",
      "title": "An Efficient Approach for Generalized Load Balancing in Multipath Packet Switched Networks",
      "authors": "Ali, GG Md Nawaz and Chakraborty, Rajib and Alam, Md Shihabul and Chan, Edward",
      "journal": "arXiv preprint arXiv:1003.3312",
      "year": "2010",
      "url": "https://scholar.google.com/scholar?q=An+Efficient+Approach+for+Generalized+Load+Balancing+in+Multipath+Packet+Switched+Networks",
      "urlSource": "https://arxiv.org/abs/1003.3312"
    }
  ],
  "2009": [
    {
      "entryType": "inproceedings",
      "citationKey": "ali2009fair",
      "title": "Fair slots assignment mechanisms of IEEE 802.11 networks for multiple access points",
      "authors": "Ali, GG Md Nawaz and Shahin, Rashma and Mowna, Nushrika",
      "booktitle": "2009 12th International Conference on Computers and Information Technology",
      "pages": "94--99",
      "year": "2009",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Fair+slots+assignment+mechanisms+of+IEEE+802.11+networks+for+multiple+access+points",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/5407158"
    },
    {
      "entryType": "inproceedings",
      "citationKey": "ali2009performance",
      "title": "Performance analysis of different routing algorithms for load distribution in multipath packet switched network",
      "authors": "Ali, GG Md Nawaz and Chakraborty, Rajib and Alam, Md Shihabul",
      "booktitle": "2009 Ninth IEEE International Conference on Computer and Information Technology",
      "volume": "2",
      "pages": "325--330",
      "year": "2009",
      "organization": "IEEE",
      "url": "https://scholar.google.com/scholar?q=Performance+analysis+of+different+routing+algorithms+for+load+distribution+in+multipath+packet+switched+network",
      "urlSource": "https://ieeexplore.ieee.org/abstract/document/5329070"
    }
  ],
  "2006": [
    {
      "entryType": "article",
      "citationKey": "aliefficient",
      "title": "AN EFFICIENT RANK BASED ADAPTIVE ALGORITHM FOR DESIGNING WEB CRAWLERS USING SIMILARITY CRITERION",
      "authors": "Ali, GG Md Nawaz and Eftakhar, SM Ashik and Waheduzzaman, Md",
      "url": "https://scholar.google.com/scholar?q=AN+EFFICIENT+RANK+BASED+ADAPTIVE+ALGORITHM+FOR+DESIGNING+WEB+CRAWLERS+USING+SIMILARITY+CRITERION",
      "urlSource": "https://www.researchgate.net/publication/299834624_An_Efficient_Rank_Based_Adaptive_Algorithm_for_Designing_Web_Crawlers_Using_Similarity_Criterion"
    }
  ]
}